import { RowDataGPU } from "../../components/GamesFPSPage/types";
import DataDisplayRowI from "../DataDisplayRowI";

/**
 * This class should be intialized with the GPUTable factory
 */
class GPURow implements DataDisplayRowI {
    endpoint: string;
    accessData: string;

    constructor() {
        this.endpoint = "/api/admin/gpu/read-range"
        this.accessData = "gpu"
    }

    create(gpu: any): RowDataGPU {
        const rowDataOrder: RowDataGPU = {
            id: gpu.id,
    
            model: gpu.model,
            
            show: gpu.show,
        
            createdAt: gpu.createdAt,
            updatedAt: gpu.updatedAt,

            numberOfGames: gpu.numberOfGames,
            numberOfRegisteredGames: gpu.numberOfRegisteredGames,

            action: "",
        };
        return rowDataOrder;
    }

    generateParams(params: any, extra: any) {
        params["new"] = extra.current
        return params
    }
}

let gpuRow: GPURow | null = null;

export default function getGPURow(): GPURow {
    if (gpuRow === null)
        gpuRow = new GPURow()
    return gpuRow
}